import './SidebarLogo.css'
import forvetLogo from '../../../assets/Sidebar/forvet_logo_white.svg'

export default function SidebarLogo() {
   return (
      <div className='sidebarLogo__container'>
        <img className='sidebarLogo__image' src={forvetLogo} alt='logo de FORVET' />
      </div>
   )
}